<template>
  <ContainerComponent class="view-container">
    <div class="tile sm-12">
      <div class="header">
        <div class="row">
          <div class="column sm-6">
            <h1 class="text-lg title">Custom selection projects</h1>
          </div>
        </div>
      </div>
      <div class="row button-group-placeholder">
        <div class="column main-section">
          <ProjectCardComponent
            :project="DEFAULT_PROJECT"
            :menu-enabled="false"
            @openCurrentProject="onOpenCurrentProject"
          />
          <div class="custom-actions" v-if="isOnlineApplication">
            <ProjectCardComponent
              v-for="(project, idx) in projects"
              :key="project.name + idx"
              :project="project"
              @openCurrentProject="onOpenCurrentProject"
              @menuClicked="commandName => onMenuClicked(commandName, idx)"
            />
            <ProjectAddCardComponent @createNewProject="onCreateNewProject" />
          </div>
        </div>
      </div>
    </div>
    <ProjectDeleteModalComponent
      ref="deleteModalComponent"
      @deleted="deleteProject"
    />
  </ContainerComponent>
</template>
<script>
import {
  ContainerComponent,
  ProjectCardComponent,
  ProjectDeleteModalComponent,
  ProjectAddCardComponent
} from '@/components';
import { DEFAULT_PROJECT, COMMAND_NAME } from '@/constants';
import readIsManaVersionFlag from '@/shared/manaVersionHelper';
import ProjectSelectionService from '@/services/projectSelectionService';
import isOnline from 'is-online';
export default {
  components: {
    ContainerComponent,
    ProjectCardComponent,
    ProjectDeleteModalComponent,
    ProjectAddCardComponent
  },
  data() {
    return {
      reset: false,
      isModalShown: false,
      modalCurrentData: {},
      projects: [],
      isMANA: readIsManaVersionFlag(),
      isOnlineApplication: false
    };
  },
  async created() {
    this.DEFAULT_PROJECT = DEFAULT_PROJECT;
    this.customSelectionProjectsKey = readIsManaVersionFlag() ? 'MANA_customSelectionProjects' : 'Global_customSelectionProjects';
    isOnline().then(async res => {
      this.isOnlineApplication = res;
      if (res) {
        await ProjectSelectionService.get(readIsManaVersionFlag(), this.customSelectionProjectsKey);
        this.projects = this.$localStorage.get(this.customSelectionProjectsKey);
      }
    })
  },
  methods: {
    onMenuClicked(commandName, projectNumber) {
      this.modalCurrentData = { commandName, projectNumber };
      switch (commandName) {
        case COMMAND_NAME.DELETE:
          this.$refs.deleteModalComponent.show();
          break;
        case COMMAND_NAME.EDIT:
          this.editProject();
          break;
        default:
          return;
      }
    },
    saveProjectToStore() {
      this.$store.commit(
        'customSelectionId',
        this.projects[this.modalCurrentData.projectNumber].id
      );
      this.$store.commit(
        'customSelectionName',
        this.projects[this.modalCurrentData.projectNumber].name
      );
      this.$store.commit(
        'customSelectionCheckedProducts',
        this.projects[this.modalCurrentData.projectNumber].checkedProducts
      );
    },
    async deleteProject() {
      await ProjectSelectionService.delete(this.projects[this.modalCurrentData.projectNumber].id, this.customSelectionProjectsKey);

      this.projects = this.$localStorage.get(this.customSelectionProjectsKey);
    },
    editProject() {
      this.saveProjectToStore();
      this.$router.push({
        name: 'custom-selection-edit',
        params: { projectNumber: this.modalCurrentData.projectNumber }
      });
    },
    onOpenCurrentProject(project) {
      this.$store.commit(
        'customSelectionCheckedProducts',
        project.checkedProducts
      );
      this.$store.commit('customSelectionName', project.name);
      this.$router.push({ name: 'radio' });
    },
    onCreateNewProject() {
      this.$router.push({ name: 'custom-selection-create' });
    }
  },
  watch: {
    isMANA: function (val) {
      this.$localStorage.set('isMANAVersion', val);
      window.location.reload();
    }
  }
};
</script>

<style lang="less" scoped>
@import '~@eds/vanilla/variables/dark.less';
@import '~@eds/vanilla/variables/global.less';
@import '../assets/common.less';

.view-container {
  overflow: scroll;
}
.tile {
  flex: 1;
  position: relative;
  background-color: @gray-09;
}
.header {
  padding: @space-base @space-large;
  .title {
    font-weight: 700;
  }
}
.button-group-placeholder {
  background-color: @gray-14;
  padding: @space-3xl @space-xl;
  flex: 1 0 auto;
}
.main-section {
  display: grid;
  grid-gap: @space-medium;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-template-rows: repeat(6, 0.3fr);
  grid-auto-rows: auto;
}
.switch-placeholder {
  text-align: right !important;
  padding-right: 98px;
}
.switch-text {
  white-space:nowrap;
}
.switch-text-ident {
  margin-right: 4px;
}
.custom-actions {
  display: contents;
}
</style>
